import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const submitInquiry = async (payload) => {
  const { data } = await axios.post(`${API}/inquiries`, payload);
  return data;
};

export const getPackages = async () => {
  const { data } = await axios.get(`${API}/packages`);
  return data;
};

export const getPaymentConfig = async () => {
  const { data } = await axios.get(`${API}/payment-config`);
  return data;
};

export const createCheckoutSession = async (package_id, email) => {
  const { data } = await axios.post(`${API}/checkout/session`, {
    package_id,
    origin_url: window.location.origin,
    email: email || null,
  });
  return data;
};

export const getCheckoutStatus = async (sessionId) => {
  const { data } = await axios.get(`${API}/checkout/status/${sessionId}`);
  return data;
};

export const getInstagramFeed = async (limit = 8) => {
  const { data } = await axios.get(`${API}/instagram-feed`, { params: { limit } });
  return data;
};
